import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HelpersModule } from '@core/components/helpers/helpers.module';
import { FilesModule } from '@core/components/files/files.module';

import { CoreCustomFormsHelpersSearchFiltersModule } from '../../helpers/filters/filters.module';
import { FillDynamicUrlLinkButtonV1FieldComponent } from './fill-dynamic-url-link-button-v1/fill-dynamic-url-link-button-v1.component';
import { ViewDynamicUrlLinkButtonV1FieldComponent } from './view-dynamic-url-link-button-v1/view-dynamic-url-link-button-v1.component';
import { SettingsDynamicUrlLinkButtonV1FieldComponent } from './settings-dynamic-url-link-button-v1/settings-dynamic-url-link-button-v1.component';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HelpersModule,
        CoreCustomFormsHelpersSearchFiltersModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ],
    declarations: [
        FillDynamicUrlLinkButtonV1FieldComponent,
        ViewDynamicUrlLinkButtonV1FieldComponent,
        SettingsDynamicUrlLinkButtonV1FieldComponent
    ],
    exports: [
        FillDynamicUrlLinkButtonV1FieldComponent,
        ViewDynamicUrlLinkButtonV1FieldComponent,
        SettingsDynamicUrlLinkButtonV1FieldComponent
    ],

})
export class CoreCustomFormsFieldDynamicUrlLinkButtonV1FieldsModule { }
